import service from '@/services/modules/portal/frm_contacto'

export default {
  FRM_CONTACTO_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      service.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  FRM_CONTACTO_UPDATE_STATUS(_, params) {
    return new Promise((resolve, reject) => {
      service.updateStatus(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
